const API_BASE = process.env.REACT_APP_API_URL || '/api'

const fetchRate = async (type, date) => {
  const headers = {}
  if (window.__sessionId) headers['X-Session-ID'] = window.__sessionId

  const response = await fetch(`${API_BASE}/rates/${type}/date?date=${encodeURIComponent(date)}`, {
    credentials: 'include',
    headers
  })
  const data = await response.json().catch(() => ({}))
  if (!response.ok || !data.success) {
    throw new Error(data.message || `Failed to fetch ${type} rate`)
  }
  return data.rate || null
}

const HistoricalRateService = {
  getGoldRate: (date) => fetchRate('gold', date),
  getDollarRate: (date) => fetchRate('dollar', date),
  getRates: (date) => Promise.all([
    fetchRate('gold', date),
    fetchRate('dollar', date)
  ]).then(([gold, dollar]) => ({ gold, dollar }))
}

export default HistoricalRateService
